module.exports = __webpack_public_path__ + "img/family_sunset.35d56754.png";